import React from 'react'
import { Link } from 'react-router-dom'
import { Hammer, ArrowLeft } from 'lucide-react'

/* ------------------------------------------------------------------ */
/*  PlaceholderPage — stub for routes not yet implemented               */
/*  Replaced one-by-one during Phase 2+. Visitor-friendly copy: no      */
/*  raw route paths, a clear "coming soon" message, and a way back.    */
/* ------------------------------------------------------------------ */

interface PlaceholderPageProps {
  title: string
  /** Route path — kept for the dev-mode hint only. */
  path: string
}

export function PlaceholderPage({ title, path }: PlaceholderPageProps) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 text-primary-600">
        <Hammer className="h-6 w-6" aria-hidden="true" />
      </div>
      <h1 className="font-display text-h1 font-bold text-neutral-900">{title}</h1>
      <p className="max-w-md text-base leading-relaxed text-neutral-600">
        Vi bygger den här sidan just nu. Den lanseras inom kort — tack för ditt tålamod!
      </p>
      <Link
        to="/"
        className="mt-2 inline-flex min-h-[44px] items-center gap-2 rounded-lg bg-primary-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2"
      >
        <ArrowLeft size={16} aria-hidden="true" />
        Till startsidan
      </Link>
      {import.meta.env.DEV && (
        <p className="mt-4 font-mono text-xs text-neutral-400">{path}</p>
      )}
    </div>
  )
}

PlaceholderPage.displayName = 'PlaceholderPage'
